import { useState } from 'react'
import { Box, Heading, Text, Flex, Grid, GridItem, IconButton, Collapse, Divider } from '@chakra-ui/react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'

export function PedidoInfo({ pedidoData, formatDate }) {
  const [showDetails, setShowDetails] = useState(false)

  const toggleDetails = () => {
    setShowDetails(!showDetails)
  }

  return (
    <Box mb={6} p={4} borderWidth="1px" borderRadius="lg" bg="#3a4a53" color="white">
      <Flex justify="space-between" align="center">
        <Heading size="md" mb={2} color="#fff">
          Informações do Pedido
        </Heading>
        <IconButton
          aria-label={showDetails ? 'Ocultar detalhes' : 'Mostrar detalhes'}
          icon={showDetails ? <FiChevronUp /> : <FiChevronDown />}
          onClick={toggleDetails}
          size="sm"
          variant="ghost"
          colorScheme="whiteAlpha"
        />
      </Flex>

      <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4} mt={2}>
        <GridItem>
          <Text>
            <strong>Número da Nota:</strong> {pedidoData.numero_nota}
          </Text>
        </GridItem>
        <GridItem>
          <Text>
            <strong>Cliente:</strong> {pedidoData.nome_cliente}
          </Text>
        </GridItem>
        <GridItem>
          <Text>
            <strong>Data:</strong> {formatDate(pedidoData.data_pedido)}
          </Text>
        </GridItem>
      </Grid>

      <Collapse in={showDetails} animateOpacity>
        <Box mt={4}>
          <Divider mb={4} opacity={0.3} />

          <Grid templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }} gap={6}>
            <GridItem>
              <Heading size="sm" mb={3} color="#37F091">
                Detalhes do Pedido
              </Heading>

              <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Número Pedido:
                  </Text>
                  <Text>{pedidoData.numero_pedido || 'Não informado'}</Text>
                </GridItem>

                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Data Prevista:
                  </Text>
                  <Text>{formatDate(pedidoData.data_prevista_despacho) || 'Não informado'}</Text>
                </GridItem>

                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Vendedor:
                  </Text>
                  <Text>{pedidoData.nome_vendedor || 'Não informado'}</Text>
                </GridItem>

                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Prazo:
                  </Text>
                  <Text>{pedidoData.descricao_prazo_producao || 'Não informado'}</Text>
                </GridItem>
              </Grid>
            </GridItem>

            <GridItem>
              <Heading size="sm" mb={3} color="#37F091">
                Status do Processamento
              </Heading>

              <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Confirmado em:
                  </Text>
                  <Text>{formatDate(pedidoData.data_pedido_confirmado) || 'Não informado'}</Text>
                </GridItem>

                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Confirmado por:
                  </Text>
                  <Text>{pedidoData.nome_usuario_pedido_confirmado || 'Não informado'}</Text>
                </GridItem>

                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Estoque confirmado em:
                  </Text>
                  <Text>{formatDate(pedidoData.data_confirma_estoque) || 'Não informado'}</Text>
                </GridItem>

                <GridItem>
                  <Text fontSize="sm" color="gray.300">
                    Estoque confirmado por:
                  </Text>
                  <Text>{pedidoData.nome_usuario_confirma_estoque || 'Não informado'}</Text>
                </GridItem>
              </Grid>
            </GridItem>
          </Grid>
        </Box>
      </Collapse>
    </Box>
  )
}
